import { callAfterResize } from './gsap-helpers.js';

function init(el){
    const tl = gsap.timeline({
        scrollTrigger: {
            trigger: el,
            start: "top center",
            end: "bottom-=100 center",
            scrub: 1,
            markers: false,
            duration: 1,
        }
    });

    console.log("init usp spotlight", el)

    const splideEl = el.closest("section")?.querySelector('[data-usp-spotlight-splide]');
    let splide;
    let splideSlidesIndexes = {};
    if (splideEl) {
        splide = new Splide(splideEl, {"arrows": false, "autoplay": false });
        splide.mount();

        Array.from(splideEl.querySelectorAll("[data-splide-slide]")).forEach((slideEl, index) => {
            const blockId = slideEl.dataset.splideSlide;
            if (blockId === undefined) return;
            splideSlidesIndexes[blockId] = index; 
        });

    }
    console.log("Splide", splide, "For" , splideEl)

    const showImage = (blockId) => {
           // Check if splide instance exists
        if (!splide) {
            console.warn("Splide instance does not exist.");
            return;
        }

        // find the corresponding splide index for that blockId
        const splideIndex = splideSlidesIndexes[blockId]
        console.log("BlockId", blockId, "Splide Index", splideIndex, splideSlidesIndexes)

        // Check if splideIndex is valid
        const slideCount = splide.length; // Total number of slides
        if (splideIndex === undefined || splideIndex < 0 || splideIndex >= slideCount) {
            console.warn(`Invalid splideIndex: ${splideIndex}. Valid range is 0 to ${slideCount - 1}.`);
            return;
        }

        // Move Splide to the specified slide
        splide.go(splideIndex);
        console.log(`Showing slide at index: ${splideIndex}`);
    }

    const setupOverlayers = () => {
        const blocks = Array.from(el.querySelectorAll('[data-block]'));

        blocks.forEach((block, blockIndex) => {
            const lineEl = block.querySelector('[data-reveal-item-line]');
            const textList = Array.from(block.querySelectorAll('[data-usp-spotlight]'));

            tl.add(`block-start-${blockIndex}`);
            textList.forEach(textEl => {
                const lineHeight = Math.ceil(window.getComputedStyle(textEl).lineHeight.replace('px', ''));
                const numberOfLines = Math.ceil(textEl.clientHeight / lineHeight);
                Array.from(textEl.querySelectorAll('.line-overlay')).forEach(overlay => overlay.remove());

                const overlayClasses = ["line-overlay", "absolute", "w-full", "opacity-60", "origin-right"];

                const addClasses = el.dataset.revealOverlayClass?.split(' ');
                if (addClasses?.length) {
                    overlayClasses.push(...addClasses);
                }


                const overlayEls = [];
                for (let i = 0; i < numberOfLines; i++) {
                    const lineOverlay = document.createElement('div');
                    lineOverlay.classList.add(...overlayClasses);
                    lineOverlay.style.top = `${i * parseInt(lineHeight)}px`;
                    lineOverlay.style.height = `${lineHeight}px`;
                    // lineOverlay.style.animation = 'line-fade-in .3s forwards';
                    // lineOverlay.style.animationDelay = `${i * 0.3}s`;
                    // lineOverlay.style.animationTimingFunction = 'linear';
                    textEl.appendChild(lineOverlay);
                    overlayEls.push(lineOverlay);
                    
                    tl.to(lineOverlay, {scaleX: 0});
                };

            });
            const blockId = block.dataset.block;
            const previousBlockId = blocks[blockIndex - 1]?.dataset.block;
            tl.fromTo(
                lineEl,
                { scaleY: 0 },          // Starting state
                { 
                    scaleY: 1, 
                    duration: 2, 
                    onStart: () => {
                        console.log("Show Image", blockIndex, blockId, blocks[blockIndex])
                        blockId && showImage(blockId);
                    },
                    onReverseComplete: () => {
                        previousBlockId && showImage(previousBlockId)
                    },
                }, // Ending state
                `block-start-${blockIndex}`  // Position label
              );
        });

    }
    setupOverlayers();

    callAfterResize(() => {
        tl.clear();
        setupOverlayers();
    }, 1);

    

}

// data-usp-spotlight
const els = document.querySelectorAll('[data-reveal-wrapper]');
Array.from(els).forEach(el => {
    init(el);
});